import { createElement, memo, useCallback } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import './index.scss';
import { getImageUrl } from '../../../lib/utils/imageUtils';
// 常量定义
const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
const FlightTheme3 = (props) => {
    const formatterDay = useCallback((date, t) => {
        var y = date.substr(0, 4), m = date.substr(5, 2), d = date.substr(8, 2);
        if (t === 'time') {
            return new Date(Number(y), Number(m) - 1, Number(d)).getTime() / 1000; // 精确到秒
        }
        return y + '.' + m + '.' + d + ' ' + week[new Date(Number(y), Number(m) - 1, Number(d)).getDay()];
    }, []);
    return <View className="flight-theme-3">
      {props.data.map((item, index) => {
        return <View className="list" key={index}>
            <Image className="img" source={{
            uri: getImageUrl(item.picurl, 330, 0)
        }}/>
            <Text x-if={!props.cornerLabelImg && props.cornerLabelWord} className="label-word" style={{
            backgroundColor: props.cornerLabelBgColor,
            color: props.cornerLabelColor
        }}>{props.cornerLabelWord}</Text>
            <Image x-if={props.cornerLabelImg} className="label-img" source={{
            uri: getImageUrl(props.cornerLabelImg || '', 66, 0)
        }}/>
            <View x-if={item.purchaserCount} className="purchaserCount">
              近1小时有{Number(props.purchaserCount ? props.purchaserCount : '') * Number(item.purchaserCount ? item.purchaserCount : '')}人想买
            </View>
            <View className="flight-city">{item.departCityName} - {item.arriveCityName}</View>
            <View className="flight-depart">
              <Text className="time">{formatterDay(item.date)}</Text>
              <Text className="discount"><Text x-if={item.discout > 0}>{item.discout / 10}折</Text>
                <Text x-else>限量</Text></Text>
              <Text x-if={item.purchaserCount} className="ticket">票少</Text>
            </View>
            <View className="price">
              <Text className="price-sym">￥</Text>
              <Text className="price-num">{item.price}</Text>
            </View>
            <View className="btn" onClick={() => props.jump(item, index)}>立即抢购</View>
          </View>;
    })}

    </View>;
};
export default memo(FlightTheme3);
